import React from "react";
import AudioPlayer from "react-h5-audio-player";
const Player = ({ playingSong }) => {
  return (
    <div className=" fixed bottom-0 z-10 w-full">
      {playingSong.length > 0 && (
        <AudioPlayer
          autoPlay
          src={playingSong[0].song}
          onPlay={(e) => console.log("onPlay")}
          // other props here
        />
      )}
    </div>
  );
};

export default Player;
